import shadows from './shadows';
import typography from './typography';

const primary = '#C5F0FF';
const secondary = '#59B1F0';
const txtPrimary = '#3a3a3a';
const txtSecondary = '#545454';

const themeObject = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1440, // default: 1920
    },
  },
  palette: {
    type: 'light',
    primary: {
      main: primary
    },
    secondary: {
      main: secondary
    },
    text: {
      primary: txtPrimary,
      secondary: txtSecondary
    },
    background: {
      dark: '#E1F7FE',
      paper: '#EFFBFF',
      default: '#FFF'
    }
  },
  shadows,
  typography,
  overrides: {
    MuiAppBar: {
      root: {
        zIndex: 1000
      },
    },
    MuiListSubheader: {
      root: {
        fontSize: 14,
        lineHeight: 2.4
      }
    },
    MuiButton: {
      root: {
        textTransform: 'capitalize',
        borderRadius: 50,
        '&$disabled': {
          color: '#6067804d'
        }
      },
      outlinedPrimary: {
        backgroundColor: '#fff',
        color: txtPrimary,
        '&:hover': {
          backgroundColor: '#ffffffe0'
        }
      }
    },
    MuiAutocomplete: {
      // inputRoot: {
      //   '&&[class*="MuiOutlinedInput-root"] $input': {
      //     padding: 1
      //   }
      // }
      inputRoot: {
        '&&[class*="MuiOutlinedInput-root"]': {
          '& $input': {
            padding: 2
          },
          padding: 4
        }
      }
    },
    MuiInputBase: {
      root: {
        fontSize: '.8rem'
      }
    },
    MuiInputLabel: {
      outlined: {
        transform: 'translate(8px, 8px) scale(1)',
      },
      formControl: {
        transform: 'translate(4px, 8px) scale(1)',
      }
    },
    MuiSelect: {
      select: {
        '&:focus': {
          borderRadius: 16,
          backgroundColor: 'transparent'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 16,
        // backgroundColor: 'lightblue',
        // '&$focused $notchedOutline': {
        //   borderColor: '#8ca103',
        //   borderWidth: 1,
        // '&&& $input': {
        //   padding: 4
        // }
        // }
      },
      input: {
        padding: '6px 8px'
      }
    },
    MuiFormLabel: {
      root: {
        // color: '#8ca103',
        fontSize: '.88rem',
        '&$focused': {
          color: secondary
        }
      }
    },
    MuiChip: {
      root: {
        height: 24,
        fontSize: 13,
      },
      label: {
        paddingLeft: 8,
        paddingRight: 6
      }
    },
    MuiMenuItem: {
      root: {
        lineHeight: 1,
        fontSize: '.8rem',
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: '.7rem',
        fontStyle: 'italic',
        letterSpacing: 0
      }
    },
    MuiTableCell: {
      root: {
        fontSize: 12,
      }
    },
    MuiCardHeader: {
      root: {
        padding: '8px 8px 0'
      }
    },
    MuiCardContent: {
      root: {
        '&:last-child': {
          padding: 0,
          paddingBottom: 8
        }
      }
    },
    MuiAlert: {
      root: {
        fontSize: 12
      }
    },
    MuiPaper: {
      outlined: {
        border: 'none'
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: 'transparent'
      }
    }

  }
};

export default themeObject;
